// sources for media
export default [
    'Free',
    'AFP',
    'RT',
    'Reuters',
    'Twitter',
    'Facebook',
    'nasa.gov',
    'vk.com',
    'NASA',
    'globallookpress.com',
    'Gettyimages.ru',
    "Wikimedia.org",
    "TopTripTip",
    "Gateway to Russia",
    "Ruptly",
]
